import { Fragment } from 'react';
import AmountSelection from '../amountSelection';
import Observer from '../common/observerHoc';

export const InvestAmount = ({
  data,
  investmentType,
  userInfo,
  amount,
  minAmount,
  maxAmount,
  investInView,
  callbackRequested,
  isMaxAmountExceed,
  isMonthlyLimitExceed,
  // fn
  visibilityChange,
  onChange,
  onAmountChangeBlur,
  investClick,
  callback,
  dismissModal,
  getSelectedAmt,

  // props
  hasUserInvestedInProduct,
}) => {
  const {
    sipEnabled,
    lumpSumEnabled,
    isinCode,
    returns,
    nfoDetails,
    returnsCategory,
    isNfo,
    purchaseMode,
  } = data;
  const { return3yr } = data.returns || {};

  const fundObj = {
    minSubsequentAmount: data.minSubsequentAmount,
    minAmount: data.minAmount,
    lumpsumMultipleAmount: data.lumpsumMultipleAmount,
    minSipAmount: data.minSipAmount,
    maxSipAmount: data.maxSipAmount,
    maxLumpsumAmount: data.maxLumpsumAmount,
    monthlyPrimeSipEnabled: data.monthlyPrimeSipEnabled,
  };
  return (
    <Fragment>
      {/* Additional header on direct plan */}
      {!isNfo || (isNfo && nfoDetails && nfoDetails.nfoState === 'LIVE') ? (
        <div className="lil-rounded-xl lil-shadow-xl lil-border-sm lil-border-grey-300 lil-p-6">
          <Observer
            identifier={'AmountSelection'}
            isActive={investInView}
            outsideView={() => visibilityChange(false)}
            insideView={() => visibilityChange(true)}
            threshold={0}
            render={() => (
              <Fragment>
                <h5 className="lil-text-center lil-text-s-18">
                  Start your investment
                </h5>
                <AmountSelection
                  amount={amount}
                  minAmount={minAmount}
                  maxAmount={maxAmount}
                  isMaxAmountExceed={isMaxAmountExceed}
                  isMonthlyLimitExceed={isMonthlyLimitExceed}
                  onChange={onChange}
                  onAmountChangeBlur={onAmountChangeBlur}
                  showOkayButton={false}
                  investmentType={investmentType}
                  hideTips
                  investClick={investClick}
                  scrollOffset={110}
                  sipGraphId={'graph-desktop'}
                  callbackRequested={callbackRequested}
                  handleRequestCallBack={callback}
                  isFund={true}
                  sipEnabled={sipEnabled}
                  lumpSumEnabled={lumpSumEnabled}
                  dismissModal={dismissModal}
                  isinCode={isinCode}
                  returns={returns}
                  categoryDetails={returnsCategory}
                  fromSingleFundPage={true}
                  isNfo={isNfo}
                  return3yr={return3yr}
                  selectedFund={fundObj}
                  hasUserInvestedInProduct={hasUserInvestedInProduct}
                  sendSelectedAmt={getSelectedAmt}
                  userInfo={userInfo}
                  purchaseMode={purchaseMode}
                />
              </Fragment>
            )}
          />
        </div>
      ) : (
        ''
      )}

      {/* <div className="lil-mt-6">
        <img
          className="lil-w-full"
          src="https://assets1.cleartax-cdn.com/cleartax/images/1630607117_image229.png"
          alt="risk"
        />
      </div> */}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/investAmount.tsx